import { Form } from "react-bootstrap";
import SearchIcon from "../../../../Custom-imeges/SearchIcon";
import { Dropdown } from "react-bootstrap";
import ConversationFilterIcon from "../../../../Custom-imeges/ConversationFilterIcon";
import { Box, Typography } from "@mui/material";
import { TrueMarkIcon } from "../../../../Custom-imeges/TrueMarkIcon";
import { soundEffectVoiceData } from "../../../../Types/VideoSuite-Types";
import { useState } from "react";
import { SoundEffectCategory } from "../../../../Helper";
import { GetSoundEffectRequest } from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
interface SoundEffectFilterProps {
  searchInputValue: string;
  setSearchInputValue: (value: string) => void;
  soundEffectData: soundEffectVoiceData[];
  setSoundEffectParams?: (data: GetSoundEffectRequest) => void;
}
const SoundEffectFilter = ({
  soundEffectData,
  searchInputValue,
  setSearchInputValue,
  setSoundEffectParams,
}: SoundEffectFilterProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [filteredSoundEffectCategories, setFilteredSoundEffectCategories] =
    useState<number[]>([]);

  const soundEffectCategories = soundEffectData?.reduce<number[]>(
    (acc, curr) => {
      if (!acc.includes(curr.category)) {
        acc.push(curr.category);
      }
      return acc;
    },
    []
  );

  const filterCounter = soundEffectCategories
    ? filteredSoundEffectCategories.length
    : 0;

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleItemClick = (id: number) => {
    setFilteredSoundEffectCategories((prev: number[]) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleApplyFiltration = () => {
    if (filteredSoundEffectCategories.length > 0) {
      if (setSoundEffectParams)
        setSoundEffectParams({
          categories: filteredSoundEffectCategories,
        });
      setIsFilter(true);
    } else {
      if (setSoundEffectParams) setSoundEffectParams({});
      setIsFilter(false);
    }
    setDropdownOpen(false);
  };

  const handleResetAll = () => {
    setFilteredSoundEffectCategories([]);
    if (setSoundEffectParams) setSoundEffectParams({});
    setIsFilter(false);
    setDropdownOpen(false);
  };

  const handleSelectAll = () => {
    if (soundEffectCategories?.length === 0) return;
    setFilteredSoundEffectCategories(soundEffectCategories);
  };

  const handleResetSelectionPersona = () => {
    if (filteredSoundEffectCategories?.length === 0) return;
    setFilteredSoundEffectCategories([]);
  };

  return (
    <Box className="sound-effect-filter-container ">
      <Box
        className="search-input-container"
        sx={{
          padding: "1px 6px",
        }}
      >
        <Form.Label className="mb-0" htmlFor="historySearch">
          <SearchIcon className="filter-search-icon" />
        </Form.Label>
        <Form.Control
          id="historySearch"
          placeholder="Search for sound effect..."
          value={searchInputValue}
          onChange={(e) => setSearchInputValue(e.target.value)}
        />
        <div className="Filter-style">
          <Dropdown
            show={dropdownOpen}
            onToggle={toggleDropdown}
            autoClose="outside"
          >
            <Dropdown.Toggle className="bg-transparent border-0">
              <ConversationFilterIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              className={`${dropdownOpen ? "filter-menu show" : "filter-menu"}`}
            >
              <Dropdown.Header className="d-flex align-items-center justify-content-between">
                <div className="d-flex flex-column">
                  <span>
                    Filter
                    {filterCounter > 0 && (
                      <span className="ms-2 personaCounter">
                        {filterCounter}
                      </span>
                    )}
                  </span>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        opacity: soundEffectCategories?.length > 0 ? 1 : 0.7,
                        userSelect: "none",
                        cursor:
                          soundEffectCategories?.length > 0
                            ? "pointer"
                            : "not-allowed",
                      }}
                    >
                      <span className="font-blue" onClick={handleSelectAll}>
                        Select all
                      </span>
                    </Typography>
                    <Typography
                      sx={{
                        opacity:
                          filteredSoundEffectCategories?.length > 0 ? 1 : 0.7,
                        userSelect: "none",
                        cursor: filteredSoundEffectCategories?.length
                          ? "pointer"
                          : "not-allowed",
                      }}
                    >
                      <span
                        className="font-blue ms-3"
                        onClick={handleResetSelectionPersona}
                      >
                        Deselect
                      </span>
                    </Typography>
                  </Box>
                </div>
                <img className="Close-menu-personas" onClick={toggleDropdown} />
              </Dropdown.Header>
              <div className="filters">
                <div className="personas">
                  <div className="categories overflow-x-hidden overflow-y-auto">
                    {soundEffectCategories?.length > 0 ? (
                      soundEffectCategories?.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          className={`d-flex align-items-center gap-1 ${
                            filteredSoundEffectCategories?.includes(item)
                              ? "selected"
                              : ""
                          }`}
                          onClick={() => handleItemClick(item)}
                        >
                          <div
                            className={`persona-checkbox ${
                              filteredSoundEffectCategories?.includes(item) &&
                              "checked"
                            }`}
                          >
                            {filteredSoundEffectCategories?.includes(item) && (
                              <TrueMarkIcon />
                            )}
                          </div>
                          <p className="personaFilterItem mb-0">
                            {SoundEffectCategory[item]}
                          </p>
                        </Dropdown.Item>
                      ))
                    ) : (
                      <div className="no-personas">
                        <p className="font-blue no-personas-text">Loading...</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="filter-buttons d-flex flex-column">
                  <button
                    className={`apply-btn ${
                      filterCounter === 0 ? "disable-btn" : "not-disable"
                    }`}
                    disabled={filterCounter === 0}
                    onClick={handleApplyFiltration}
                  >
                    Apply
                  </button>
                  <span
                    className="font-blue mt-2"
                    style={{ textDecoration: "underline" }}
                    onClick={handleResetAll}
                  >
                    Reset all
                  </span>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          {isFilter && <span className="circle-red"></span>}
        </div>
      </Box>
    </Box>
  );
};

export default SoundEffectFilter;
